import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import Indicator from './Indicator';
import NameTagGroup from './NameTagGroup';
/**
 * Indicator Group Compact is a type of **molecule** represents users by circular indicators that only applies when the indicators appear on a Page Thumbnail
 */
const IndicatorGroupCompact = ({ className, maxVisibleIndicators, nameTagGroupClassName, users, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    const indicatorBackgroundColors = [
        'bg-real-time-collaboration-blue',
        'bg-real-time-collaboration-red',
        'bg-real-time-collaboration-purple',
        'bg-real-time-collaboration-green',
    ];
    const [isExpanded, setIsExpanded] = useState(false);
    const exapandContent = () => {
        setIsExpanded(true);
    };
    const collapseContent = () => {
        setIsExpanded(false);
    };
    return (_jsxs("div", { onMouseEnter: exapandContent, onMouseLeave: collapseContent, ...dataAttributes, children: [_jsx("ol", { className: buildClassName(className, 'm-auto flex -space-x-4 pl-0 transition-all', {
                    'opacity-0': isExpanded,
                }), children: users.map((user, index) => index < (maxVisibleIndicators ?? users.length) && (_jsx("li", { className: "list-none", children: _jsx(Indicator, { className: buildClassName(indicatorBackgroundColors[index % indicatorBackgroundColors.length]), firstName: user.firstName, lastName: user.lastName }) }, user.id ?? index))) }), _jsx(AnimatePresence, { children: isExpanded && (_jsx(motion.section, { className: buildClassName('scrollbar-hide', nameTagGroupClassName), initial: "invisible", animate: "visible", exit: "exit", style: { zIndex: 30 }, transition: { type: 'spring', duration: 0.6 }, variants: {
                        invisible: {
                            opacity: 0,
                            y: '-40%',
                            height: 0,
                        },
                        visible: {
                            opacity: 1,
                            y: 0,
                            height: 'auto',
                            overflowY: 'scroll',
                        },
                        exit: {
                            opacity: 0,
                            height: 0,
                        },
                    }, children: _jsx(NameTagGroup, { className: "items-start gap-1", users: users }) })) })] }));
};
export default IndicatorGroupCompact;
//# sourceMappingURL=IndicatorGroupCompact.js.map